import type { UserRolesResponseData } from '@app/api/v1/auth/roles/route'
import ApiRoutes from '@lib/routes/ApiRoutes'
import { RequestMethod } from '../consts'
import internalJsonFetch from '../internalJsonFetch'

export default async function getUserRoles() {
  const response = await internalJsonFetch<UserRolesResponseData>({
    authenticated: true,
    requestMethod: RequestMethod.GET,
    url: ApiRoutes.v1.auth.roles,
  })

  if (!response.success) {
    return []
  }

  return response.data ?? []
}
